import { useState, useEffect } from 'react';
import { lyveGateway } from '../lib/lyveGateway';

// Direct (uncached) fetch hook for the Lyve gateway. Returns
// { data, loading, error }. `fnName` is a key of `lyveGateway`; `payload` is
// passed straight through. Uncached so live feeds (e.g. streams) stay fresh.
export default function useGateway(fnName, payload) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const serialized = JSON.stringify(payload || {});

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(null);
    const fn = lyveGateway[fnName];
    if (!fn) {
      setError(new Error(`Unknown gateway fn: ${fnName}`));
      setLoading(false);
      return undefined;
    }
    fn(payload)
      .then((d) => {
        if (alive) setData(d);
      })
      .catch((e) => {
        if (alive) setError(e);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fnName, serialized]);

  return { data, loading, error };
}
